import { useDispatch, useSelector } from "react-redux";

import { useNavigate, useLocation } from "react-router-dom";
import React from "react";
import { Button, Container, Box, Grid, Tab, Tabs, Pagination, Card, Typography } from "@mui/material";
import axios from "axios";

export default function History() {
  let dispatch = useDispatch()
  let location = useLocation()
  const navigate = useNavigate();
  const { data } = location.state

  const downloadFile = async (repoId, commitId) => {

    const response = await axios.get(
      `/download/${repoId}?commit_id=${commitId}`,
      {
        responseType: "blob"
      }
    );

    const disposition = response.headers["content-disposition"];

    let filename = commitId;

    if (disposition) {
      const match = disposition.match(/filename="(.+)"/);
      if (match) filename = match[1];
    }

    const blob = new Blob([response.data], {
      type: response.headers["content-type"]
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;
    link.download = filename;

    document.body.appendChild(link);

    link.click();

    link.remove();

    window.URL.revokeObjectURL(url);
  };
  return (
    <>
      <Container maxWidth="false" className="py-3">

        <Box sx={{ p: 1, my: 2, borderRadius: "5px", backgroundColor: "#98e1f1ff", display: "flex", alignItems: "center", justifyContent: 'space-between' }}>
          <Typography >Versions of {data?.original_filename}</Typography>
          <Typography className="btn-primary" onClick={() => navigate(location.state.prevNav)} sx={{ cursor: "pointer" }}>Documents→</Typography>
        </Box>
        <Grid container spacing={1}>
          {data?.history?.map((h) => {
            return <Grid size={{ xs: 12, sm: 6, md: 6 }} spacing={1}>
              <Card sx={{ border: "1px solid #ccc", borderRadius: "5px", mt: 2 }}>

                <Box sx={{ p: 2, backgroundColor: "#f5f5f5", fontWeight: 800 }}>{h.commit_id}</Box>
                <Box sx={{ p: 1, }} >💬 {h.message} </Box>
                <Box sx={{ p: 1, }} >📁 {data.repo_name} </Box>
                <Box sx={{ p: 1 }}>📅 Created on {h.date?.replace("T", " ")} </Box>
                <Box sx={{ p: 1 }}>👤 Author {h.author} </Box>

                <Box sx={{ p: 1 }}>
                  <hr />
                </Box>
                <Box sx={{ p: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Box
                    onClick={() => { downloadFile(data.id, h.commit_id) }}
                    sx={{ p: 1, fontSize: 12, border: "1px solid #ccc", borderRadius: "5px" }}>
                    Download Version
                  </Box>


                </Box>
              </Card>
            </Grid>
          })}
        </Grid>
      </Container>
    </>
  )
}